import { buildBaseThemeMapping } from '../../shared/base-theme';
// dojo
import button from './dojo/button.m.css';
import checkbox from './dojo/checkbox.m.css';
import icon from './dojo/icon.m.css';
import label from './dojo/label.m.css';
import radio from './dojo/radio.m.css';
import tooltip from './dojo/tooltip.m.css';
// base-widgets
import accordion2 from './base-widgets/accordion2.m.css';
import slidingpane from './base-widgets/sliding-pane.m.css';
import tabcontainer from './base-widgets/tab-container.m.css';
// audio
import audio from './audio/audio.m.css';
// video
import video from './video/video.m.css';
// backview
import backview from './backview/backview.m.css';
// card
import expanded from './card/expanded.m.css';
import tgf from './card/tgf.m.css';
// learning-activity
import activity from './learning-activity/activity.m.css';
// lcc-app
import content from './lcc-app/content.m.css';
import footer from './lcc-app/footer.m.css';
import heading from './lcc-app/heading.m.css';
import splash from './lcc-app/splash.m.css';
// lcc-rcs
import document from './lcc-rcs/document.m.css';
// book-widgets
import statusicon from './book-widgets/status-icon.m.css';
import topicaccordion from './book-widgets/topicaccordion.m.css';
import topicgroup from './book-widgets/topicgroup.m.css';
import topicpage from './book-widgets/topicpage.m.css';
// prepost-viz
import prepost from './prepost-viz/prepost-viz.m.css';
import progress from './prepost-viz/progress-viz.m.css';
// table-of-contents
import drawer from './table-of-contents/drawer.m.css';
import toc from './table-of-contents/toc.m.css';
import trigger from './table-of-contents/trigger.m.css';
// quiz-widgets
import discussion from './quiz-widgets/discussion.m.css';
import flashcard from './quiz-widgets/flashcard.m.css';
import mcquestion from './quiz-widgets/mcquestion.m.css';
import pretestreview from './quiz-widgets/pretest-review.m.css';
import prometricreview from './quiz-widgets/prometric-review.m.css';
import prometric from './quiz-widgets/prometric.m.css';
import questionfeedback from './quiz-widgets/questionfeedback.m.css';
import quizfolder from './quiz-widgets/quizfolder.m.css';
import singlestep from './quiz-widgets/singlestep.m.css';
// landing-page
import landingpagegeneral from './landing-page/general.m.css';
import welcomeview from './landing-page/welcome-view.m.css';
// explore-view widgets
import carouselview from './explore-view/carousel-view.m.css';
import chooser from './explore-view/chooser.m.css';
import contentorder from './explore-view/content-order.m.css';
import navcard from './explore-view/nav-card.m.css';
// variants
import ascm2024demoVariant from './variants/ascm2024demo.m.css';
import ascmpreviewVariant from './variants/ascmpreview.m.css';
import cltdVariant from './variants/cltd.m.css';
import cltd2024Variant from './variants/cltd2024.m.css';
import cltd2024ssVariant from './variants/cltd2024ss.m.css';
import { default as cpim2Variant, default as cpimVariant } from './variants/cpim.m.css';
import cpim2024Variant from './variants/cpim2024.m.css';
import cpim2024ssVariant from './variants/cpim2024ss.m.css';
import cscpVariant from './variants/cscp.m.css';
import cscp2024Variant from './variants/cscp2024.m.css';
import cscp2024ssVariant from './variants/cscp2024ss.m.css';
import ctscVariant from './variants/ctsc.m.css';
import ctsc2024Variant from './variants/ctsc2024.m.css';
import ctsc2024ssVariant from './variants/ctsc2024ss.m.css';

export default {
	theme: buildBaseThemeMapping({
		button,
		checkbox,
		label,
		icon,
		tooltip,
		radio,
		tabcontainer,
		accordion2,
		slidingpane,
		audio,
		video,
		backview,
		expanded,
		tgf,
		activity,
		heading,
		content,
		splash,
		footer,
		document,
		topicpage,
		topicgroup,
		topicaccordion,
		statusicon,
		prepost,
		progress,
		toc,
		trigger,
		drawer,
		discussion,
		flashcard,
		mcquestion,
		pretestreview,
		prometricreview,
		prometric,
		questionfeedback,
		singlestep,
		quizfolder,
		welcomeview,
		landingpagegeneral,
		contentorder,
		carouselview,
		chooser,
		navcard
	}),
	variants: {
		cscp: cscpVariant,
		cltd: cltdVariant,
		cpim: cpimVariant,
		cpim2: cpim2Variant,
		ctsc: ctscVariant,
		ascmpreview: ascmpreviewVariant,
		ascm2024demo: ascm2024demoVariant,
		cscp2024: cscp2024Variant,
		cscp2024ss: cscp2024ssVariant,
		cltd2024: cltd2024Variant,
		cltd2024ss: cltd2024ssVariant,
		cpim2024: cpim2024Variant,
		cpim2024ss: cpim2024ssVariant,
		ctsc2024: ctsc2024Variant,
		ctsc2024ss: ctsc2024ssVariant
	}
};
